export default __webpack_public_path__ + "static/3- pullup-047e1bced6c529592a997fea55891099.gif";